import { ChannelSightApi } from '../types/api/channel-sight-api';
import { Method, callAxios } from '../axios';

export const channelSightApiFetchers = {
  getProductsDataFeed: async ({ params }: { params: ChannelSightApi.GetChannelSightParams }) => {
    const GET_PRODUCTS_FEED_URL = `${params.feedUrl}&pid=${params.productIds}`;

    const response = await callAxios<{ response: ChannelSightApi.GetChannelSightResponse }>({
      method: Method.GET,
      url: GET_PRODUCTS_FEED_URL,
    });

    return response.data;
  },
};
